import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Search, Crown, User } from 'lucide-react';

const UserSearchCard = ({
  searchEmail,
  setSearchEmail,
  onSearch,
  searchLoading,
  searchResult,
  toggleLoading,
  onToggleTier,
}) => (
  <Card className="bg-gray-800 border-gray-700">
    <CardHeader>
      <CardTitle className="text-white flex items-center gap-2">
        <Search className="w-5 h-5 text-purple-400" />
        Search User
      </CardTitle>
      <CardDescription className="text-gray-400">
        Find a user by email to view or update their subscription
      </CardDescription>
    </CardHeader>
    <CardContent>
      <form onSubmit={onSearch} className="flex gap-3">
        <Input
          type="email"
          value={searchEmail}
          onChange={(e) => setSearchEmail(e.target.value)}
          placeholder="user@example.com"
          className="flex-1 bg-gray-700 border-gray-600 text-white placeholder:text-gray-500"
          required
          data-testid="admin-search-input"
        />
        <Button
          type="submit"
          className="bg-purple-600 hover:bg-purple-700 text-white"
          disabled={searchLoading}
          data-testid="admin-search-btn"
        >
          {searchLoading ? 'Searching...' : 'Search'}
        </Button>
      </form>

      {searchResult && (
        <div className="mt-6 p-4 bg-gray-700/50 rounded-lg border border-gray-600" data-testid="admin-search-result">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center">
                {searchResult.tier === 'pro' ? (
                  <Crown className="w-5 h-5 text-yellow-400" />
                ) : (
                  <User className="w-5 h-5 text-gray-400" />
                )}
              </div>
              <div>
                <p className="font-medium text-white">{searchResult.name || searchResult.email}</p>
                <p className="text-sm text-gray-400">{searchResult.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Badge
                className={searchResult.tier === 'pro' ? 'bg-purple-600 text-white' : 'bg-gray-600 text-gray-300'}
              >
                {searchResult.tier === 'pro' ? 'Pro' : 'Free'}
              </Badge>
              <Button
                size="sm"
                onClick={() => onToggleTier(searchResult.email, searchResult.tier)}
                disabled={toggleLoading === searchResult.email}
                className={
                  searchResult.tier === 'pro'
                    ? 'bg-red-600 hover:bg-red-700 text-white'
                    : 'bg-green-600 hover:bg-green-700 text-white'
                }
                data-testid="admin-toggle-tier-btn"
              >
                {toggleLoading === searchResult.email
                  ? 'Updating...'
                  : searchResult.tier === 'pro'
                  ? 'Downgrade to Free'
                  : 'Upgrade to Pro'}
              </Button>
            </div>
          </div>
          {searchResult.plan && (
            <p className="text-xs text-gray-500 mt-2">
              Plan: {searchResult.plan} | Created:{' '}
              {new Date(searchResult.created_at).toLocaleDateString()}
            </p>
          )}
        </div>
      )}
    </CardContent>
  </Card>
);

export default UserSearchCard;
